export default "__VITE_ASSET__DPXylhXu__"